import { Module } from 'vuex';
import { RootState } from '@/store/index';
import { RouteLocationNormalizedLoaded, RouteRecordName, RouteParams, LocationQuery } from 'vue-router';

type PreviousRoute = {
  name: RouteRecordName | undefined | null,
  path: string,
  params: RouteParams,
  query: LocationQuery,
  fullPath: string,
};

type routerState = {
  loginTransitionPageName: RouteRecordName | undefined | null;
  loginTransitionPageParams: RouteParams;
  loginTransitionPageQuery: LocationQuery;
  previousRoute: PreviousRoute | null;
};

const homeName = 'f00';

const routerModule: Module<routerState, RootState> = {
  namespaced: true,
  state: {
    loginTransitionPageName: homeName, // ログインで遷移するページ名
    loginTransitionPageParams: {},
    loginTransitionPageQuery: {},
    previousRoute: null,
  },
  getters: {
    loginTransitionPageData(state) {
      return {
        name: state.loginTransitionPageName,
        params: state.loginTransitionPageParams,
        query: state.loginTransitionPageQuery,
      };
    },
    previousRoute(state) {
      return state.previousRoute;
    },
  },

  mutations: {
    setLoginTransitionData(state, route: RouteLocationNormalizedLoaded) {
      state.loginTransitionPageName = route.name;
      state.loginTransitionPageParams = route.params;
      state.loginTransitionPageQuery = route.query;
    },
    initLoginTransitionData(state) {
      state.loginTransitionPageName = homeName;
      state.loginTransitionPageParams = {};
      state.loginTransitionPageQuery = {};
    },
    setPreviousRoute(state, route: RouteLocationNormalizedLoaded) {
      state.previousRoute = {
        name: route.name,
        path: route.path,
        params: route.params,
        query: route.query,
        fullPath: route.fullPath,
      };
    },
    clearPreviousRoute(state) {
      state.previousRoute = null;
    },
  },

  actions: {},
};

export default routerModule;
